import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "basic-layout" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "basic-layout company-preview",
      href: _ctx.info.url,
      target: "_blank"
    }, [
      _createElementVNode("img", {
        class: "rounded-lg",
        src: _ctx.$iconPath(_ctx.info.imgUrl),
        loading: "lazy"
      }, null, 8, _hoisted_3)
    ], 8, _hoisted_2)
  ]))
}